import { render, staticRenderFns } from "./InvestigateTopic.vue?vue&type=template&id=2244c3c6&scoped=true&"
import script from "./InvestigateTopic.vue?vue&type=script&lang=js&"
export * from "./InvestigateTopic.vue?vue&type=script&lang=js&"
import style0 from "./InvestigateTopic.vue?vue&type=style&index=0&id=2244c3c6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2244c3c6",
  null
  
)

export default component.exports